/**
 * Switches the product-card image from the visible mobile arrow.
 * Mobile always has access to the product's second image; desktop hover is
 * still controlled by the section's secondary-image setting.
 */
(() => {
  const mobileViewport = window.matchMedia('(max-width: 989px)');
  const getProductCard = (target) => target.closest('.product-card-wrapper');
  const setSecondaryImage = (card, visible) => {
    card.classList.toggle('is-secondary-image-visible', visible);
    const toggle = card.querySelector('.product-card__image-toggle');

    toggle?.setAttribute('aria-pressed', String(visible));
    toggle?.setAttribute('aria-label', visible ? 'Show first product image' : 'Show second product image');
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!mobileViewport.matches) return;

      const card = getProductCard(event.target);
      const toggle = card?.querySelector('.product-card__image-toggle');
      if (!card || !toggle) return;

      const bounds = toggle.getBoundingClientRect();
      const isToggle = event.target.closest('.product-card__image-toggle');
      const isWithinToggle =
        event.clientX >= bounds.left &&
        event.clientX <= bounds.right &&
        event.clientY >= bounds.top &&
        event.clientY <= bounds.bottom;

      // The full-card product link can cover the arrow, depending on card
      // style. The coordinate fallback keeps the visible arrow actionable.
      if (!isToggle && !isWithinToggle) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      setSecondaryImage(card, !card.classList.contains('is-secondary-image-visible'));
    },
    true
  );
})();
